import { render } from "./Search.vue?vue&type=template&id=3392e897"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/multiPaper/Search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3392e897"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3392e897', __exports__)) {
    api.reload('3392e897', __exports__)
  }
  
  module.hot.accept("./Search.vue?vue&type=template&id=3392e897", () => {
    api.rerender('3392e897', render)
  })

}


export default __exports__